import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const StaticSocialIcon = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=201557757721"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Whatsapp"
      className="group fixed end-0 bottom-0 z-[40] m-4 flex size-12 cursor-pointer items-center justify-center rounded-full border bg-green-500 p-2 text-5xl text-white transition-all duration-300 hover:scale-110 hover:bg-green-600"
    >
      <FaWhatsapp className="h-full w-full transition-all duration-300 group-hover:bg-green-600 hover:scale-110" />
    </a>
  );
};

export default StaticSocialIcon;
